export const v3DynamicSubNav = {
  _type: 'v3DynamicSubNav',
  module: 'v3DynamicSubNav',
};
